export default defineNuxtPlugin(() => {

})
